export default {
    name: 'MenuBaseForm',
    inject: ['eventBus'],
    data() {
        return {
            action: '',
            steps: [
                {
                    label: 'Basic Information',
                    slot: 'page1'
                },
                {
                    label: 'Select Items',
                    slot: 'page2'
                },
                {
                    label: 'Create menu',
                    slot: 'page3',
                    options: {
                        nextDisabled: false
                    }
                }
            ],
            menu : {
                menuName: '',
                description: '',
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
                fromTime : '',
                toTime : '',
                menuItems : []
            },
        }
    },
    methods: {
        setAction(actionParam) {
            this.action = actionParam;
        },
        clearMenu() {
            this.menu = {
                menuName: '',
                description: '',
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
                fromTime : '',
                toTime : '',
                menuItems : []
            };
            this.$router.push('/menus');
        },
        async handleBtnSave() {
            //await this.$store.dispatch(this.action, this.menu);
            //this.clearMenu();
        },
        handleBtnCancel() {
            this.clearMenu();
        },
        onComplete() {

        },
        async nextClicked(currentPage) {
            if (currentPage < 2) {
              this.eventBus.$emit("onNextEvent");
              return true;
            }
            else {
              await this.$store.dispatch(this.action, this.menu);
              this.clearMenu();
            }
            
        },
        backClicked(currentPage) {
            this.eventBus.$emit("onBackEvent");
            return true;
        } 
    },

}